import { render, staticRenderFns } from "./recipesCategories.vue?vue&type=template&id=821ab754"
import script from "./recipesCategories.vue?vue&type=script&lang=js"
export * from "./recipesCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports